module.exports = __webpack_public_path__ + "static/img/EN.2b6e6ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/banners/h5/EN.png
// module id = jPI2
// module chunks = 1